export default {options:{api:'notification',version:1},children:[]}